
export const PRIZES_FILENAME = 'pve-leaderboard.json';

export const LDB_BANNER_PRICE = {
  WEEK: 10,
  MONTH: 30,
  YEAR: 200,
};
